import React from "react"

export const EyeOpenIcon = () => {
  return <span className="glyphicon glyphicon-eye-open"></span>
}

export const DownloadIcon = () => {
  return <span className="glyphicon glyphicon-download-alt"></span>
}
